import { Plugin } from '@atlaskit/editor-prosemirror/state';

// Copied from packages/editor/editor-common/src/safe-plugin/index.ts
// Swapped to any types to avoid adding prosemirror-model as a dependency
export class SafePlugin extends Plugin {
  // This variable isn't (and shouldn't) be used anywhere. Its purpose is
  // to distinguish Plugin from SafePlugin, thus ensuring that an 'unsafe'
  // Plugin cannot be assigned as an item in EditorPlugin → pmPlugins.

  constructor(spec) {
    super(spec);
  }
}